// @flow
import _ from "lodash"

import type { Currency, FlightId, PassengerId, PriceTotal } from "mmb/types/primitiveTypes"

export type seatingApiPayload = {
  category: "seating",
  booked_at: string,
  amount: PriceTotal,
  useBalance: boolean,
  currency: Currency,
  segments: {
    [fid: FlightId]: {
      [paxId: PassengerId]: string,
    },
  },
}

type mamboSeatingApiPayload = {
  amount: PriceTotal,
  currency: Currency,
  seats: Array<{
    column: string,
    flight: FlightId,
    passenger: PassengerId,
    row: string,
  }>,
  use_credits: boolean,
}

export const mapToMamboPayload = ({
  segments,
  amount,
  currency,
  useBalance,
}: seatingApiPayload): mamboSeatingApiPayload => {
  const seats = []
  _.forEach(segments, (segment, flightId) => {
    _.forEach(segment, (seat, paxId) => {
      const [row, column] = seat.split("-")

      seats.push({
        column,
        row,
        passenger: paxId,
        flight: flightId,
      })
    })
  })
  return {
    amount,
    currency,
    use_credits: useBalance || false,
    seats,
  }
}
